
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.33 4.643c.719.45 1.079.675 1.202.963a1 1 0 010 .788c-.123.288-.483.513-1.203.963L4.948 9.47c-.799.5-1.198.75-1.528.723a1 1 0 01-.723-.401C2.5 9.527 2.5 9.055 2.5 8.113V3.887c0-.942 0-1.413.197-1.679a1 1 0 01.723-.4c.33-.027.729.223 1.528.722l3.381 2.113z","stroke":"#1C2F45","stroke-linejoin":"round"}})])
          )
        }
      }
    